import React, { useEffect, useState } from "react";
import Product from "@components/Product/partials/Product";
import API from "@utils/plugins/API";
import { useHistory } from "react-router-dom";
import { hideSpinner, showSpinner } from "@redux/spinner/Action";
import { useDispatch } from "react-redux";

const ProductSelect = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [campaign, setCampaign] = useState({});
  const [loading, setLoading] = useState(false);

  const getPreOrders = async () => {
    try {
      const response = await API.get("preorder-campaign");
      setCampaign(response.data?.campaign);
      dispatch(hideSpinner());
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(async () => {
    dispatch(showSpinner("Please wait..."));
    setLoading(true);
    await getPreOrders();
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <div style={{ height: "100vh" }} />
      ) : (
        <div>
          <div className={"mt-15"}>
            <img
              alt="campaign"
              src={
                campaign.image && campaign.image.startsWith("https://")
                  ? campaign.image
                  : campaign.image
                  ? campaign.image.replace(/^http:\/\//i, "https://")
                  : ""
              }
              className="w-full"
            />
          </div>
          <div
            className="flex flex-col px-2 xl:px-22 lg:px-8 justify-center mx-auto mt-15 mx-3"
            style={{ maxWidth: "1800px" }}
          >
            <div className="mt-3 md:mt-16">
              <div
                className={
                  "text-xl md:text-4xl lg:text-6xl text-primary-500 font-bold text-center mb-1 md:mb-3"
                }
              >
                {campaign.title}
              </div>
            </div>
            <div className="px-2 lg:px-20">
              <p className="text-xs md:text-lg lg:text-2xl text-center text-brand-gray font-light">
                {campaign.description}
              </p>
            </div>
            <div
              className={
                "text-lg md:text-3xl text-gray-700 font-bold text-center mt-6 md:mt-14 md:mb-6 text-brand-gray"
              }
            >
              Zgjidh modelin
            </div>
            <div
              className={
                "grid grid-cols-2 gap-1 lg:flex lg:flex-row lg:justify-between flex-wrap mt-2"
              }
            >
              {campaign.products?.map((product) => (
                <Product
                  key={product.id}
                  title={product.name}
                  description={product.description}
                  imageSrc={product.image_url}
                  onClick={() => {
                    // window.open('https://www.one.al/eshop/listing/DEVICE/Phones/handset/TELEFONA?filter=%5b%7b%22key%22:%22Brand%22,%22value%22:%22Samsung%22%7d%5d')
                    history.push(`/product/${product.id}`);
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductSelect;
